import {Component, Input, Inject, OnInit} from '@angular/core';
import {confirmValidator} from "../confirm-validator";
import {FormBuilder, Validators} from "@angular/forms";
import {StateService} from '@uirouter/core';
import {LocalStorageService} from "angular-2-local-storage";
import {ApiService} from "../../utils/api.service";
import {FormService} from "../../utils/form.service";
import {WindowRefService} from "../../utils/window.service";
import {AppService} from "../../utils/app.service";
import {AnalyticsService} from "../../utils/analytics.service";
import { env } from 'process';
@Component({
    selector: 'restore-page',
    template: require('./restore.html'),
})

export class RestorePageComponent implements OnInit {
    private _window: any;
    private step: any;
    private type: any;
    private restoreForm = {
        form: null,
        $submitting: false,
        $submitted: false,
        $visible: false,
        $errorMsg: '',

        username: ''
    };
    private resetForm = {
        form: null,
        $submitting: false,
        $submitted: false,
        $visible: false,
        $errorMsg: '',

        username: '',
        password: '',
        password_confirm: ''
    };
    @Input() params: any;
    @Input() config: any;

    infoTextMap = {
        CB: 'ClientBooks',
        SPROUT: 'Sprout',
    };

    infoText = this.infoTextMap[process.env.MODE] || '1-800Accountant';

    constructor(@Inject(AppService) private app: any,
                @Inject(ApiService) private api: any,
                @Inject(AnalyticsService) private Analytics: any,
                @Inject(FormService) private Form: any,
                private localStorageService: LocalStorageService,
                windowRef: WindowRefService,
                private Location: StateService,
                @Inject(FormBuilder) private fb: FormBuilder
    ) {
        this._window = windowRef.nativeWindow;
        this.restoreForm.form = this.fb.group({
            username: [this.restoreForm.username, [
                Validators.required,
                Validators.email
            ]]
        });
        this.resetForm.form = this.fb.group({
            password: [this.resetForm.password, [
                Validators.required,
                Validators.minLength(6)
            ]],
            password_confirm: [this.resetForm.password_confirm, [
                Validators.required,
                Validators.minLength(6),
                confirmValidator('password')
            ]]

        });
    }

    ngOnInit() {
        this.app.config = this.config;
        this.step = this.params.step;
        this.type = this.params.type;

        if (this.step === 'reset') {
            this.localStorageService.set('params', this.params);
        } else if (this.step === 'send' && this.params.client_id) {
            this.localStorageService.set('params', this.params);
            this._setSource();
        } else {
            this._setSource();
        }

        let appParams = <any>this.localStorageService.get('params');

        if (!appParams || !appParams.client_id) {
            this.app.setDefaultParams();
        }

        this.restoreForm.username   = this.params.username;
        this.resetForm.username   = this.params.username;
    }

    _setSource() {
        if (this.params.source === 'mobile') {
            let d:Date = new Date();
            d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
            let expires = `expires=${d.toUTCString()}`;
            document.cookie = `source=mobile; ${expires}`;
        }
    }

    _getSource() {
        const value = "; " + document.cookie;
        const parts = value.split("; " + 'source' + "=");
    
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
    }

    _removeSource() {
        let d:Date = new Date();
        d.setTime(d.getTime() + (-1 * 24 * 60 * 60 * 1000));
        document.cookie = `source=; expires=${d.toUTCString()}`;
    }

    _onSuccessRestore(data) {
        if (data.success) {
            this.Analytics.trackEvent('Password Management', 'Request password link');
            this.restoreForm.$submitting = false;
            this.step = 'check';
        } else {
            this.restoreForm.$submitting = false;
            this.restoreForm.$errorMsg = data.message;
            this.Analytics.trackEvent('Password Management', 'Error', data.message);
        }
    };

    _onFailedRestore(response) {
        let data = response.error;
        this.restoreForm.$submitting = false;
        this.Analytics.trackEvent('Password Management', 'Error', data.message);
        this.restoreForm.$errorMsg = data.message;
    };

    restore = function () {
        this.restoreForm.$submitted = true;

        if (this.restoreForm.form.valid) {
            this.restoreForm.$submitting = true;
            let authParams = <any>this.localStorageService.get('params');
            this.api.restorePassword({
                username: this.restoreForm.username,
                client_id: authParams.client_id,
                client_secret: authParams.client_secret,
                response_type: authParams.response_type,
                redirect_uri: authParams.redirect_uri,
                promo: authParams.promo
            }).then(this._onSuccessRestore.bind(this), this._onFailedRestore.bind(this));
        } else {
            this.restoreForm.$errorMsg = 'Please provide the required information and correct the mistakes';
            this.Analytics.trackEvent('Password Management', 'Error', 'Provide required information');
        }
    };
    _setCbPassword(data) {
        if (data.success && data.code !== 400) {
            this.Analytics.trackEvent('Set New Password', 'Set New Password click');
            
            this.resetForm.$submitting = false;
            this.Location.go('login', {username: this.resetForm.username});

            // Deep linking to mobile app
            if(this._getSource() === 'mobile') {
                this._removeSource();
                window.location.href  = 'clientbooks://';
            }
        } else {
            this.resetForm.$submitting = false;
            this.resetForm.$errorMsg = data.message;
            this.Analytics.trackEvent('Set New Password', 'Error', data.message);
        }
    }
    _setTaxAppPassword(data) {
        if (data.success && data.code !== 400) {
            this.Analytics.trackEvent('Set New Password', 'Set New Password click');
            this.resetForm.$submitting = false;
            let authParams = <any>this.localStorageService.get('params');
            this._window.location.href = authParams.redirect_uri
                + (authParams.redirect_uri.indexOf('?') !== -1 ? '&' : '?')
                + 'access_token=' + data.access_token + '#mainForm';
        } else {
            this.resetForm.$submitting = false;
            this.resetForm.$errorMsg = data.message;
            this.Analytics.trackEvent('Set New Password', 'Error', data.message);
        }
    }
    _handleError(data){
        this.resetForm.$submitting = false;
        this.resetForm.$errorMsg = data.error.message;
        this.Analytics.trackEvent('Set New Password', 'Error', data.error.message);
    }
    setPassword() {
        this.resetForm.$submitted = true;
        if (this.resetForm.form.valid) {
            this.resetForm.$submitting = true;
            let authParams = <any>this.localStorageService.get('params');
            if (this.app.getAppName() !== 'taxapp') {
                this.api.setNewPassword({
                    username: this.resetForm.username,
                    password_reset_token: this.params.password_reset_token,
                    password: this.resetForm.password,
                    client_id: authParams.client_id,
                    client_secret: authParams.client_secret,
                    response_type: authParams.response_type,
                    redirect_uri: authParams.redirect_uri,
                }).then(this._setCbPassword.bind(this), this._handleError.bind(this));
            } else {
                this.api.setNewTaxAppPassword({
                    username: this.resetForm.username,
                    password_reset_token: this.params.password_reset_token,
                    password: this.resetForm.password,
                    client_id: authParams.client_id,
                    client_secret: authParams.client_secret,
                    response_type: authParams.response_type,
                    redirect_uri: authParams.redirect_uri,
                    grant_type: 'password'
                }).then(this._setTaxAppPassword.bind(this), this._handleError.bind(this));
            }
        } else {
            this.resetForm.$errorMsg = 'Please provide the required information and correct the mistakes';
            this.Analytics.trackEvent('Set New Password', 'Error', 'Provide required information');
        }
    };
}